'use strict';

export default (API) => ({
    settings: {
        getBaseSettings: (appModule) => {
            const url = 'v3/settings' + (appModule ? '?appModule=' + appModule : '');
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getGlobalSettings: () => {
            const url = 'v3/globalSettings';
            const request = API.http.get(url);
            return API.handleError(request);
        }
    }
});
